const profilePT = {
    "edit": {
        "title": "Edite seu perfil",
        "form": {
            "label": {
                "profileImage": "Imagem de Perfil",
                "streetAndNumber": "Minha Rua e número da casa",
                "postalCode": "Código postal",
                "city": "Cidade",
                "country": "País",
                "vatNumber": "Número de IVA",
                "nationalTaxNumber": "Número de Imposto Nacional",
                "businessRegistrationNumber": "Número de Registro Comercial",
                "vatStatus": "Status do IVA",
                "businessType": "Tipo de Negócio",
                "vatExemptDocument": "Documento de Isenção de IVA",
                "businessCertificate": "Certificado de Negócio",
                "preferredPaymentMethod": "Método de pagamento preferido",
                "paypalEmail": "Email do Paypal",
                "accountHolderName": "Nome do Titular da Conta Bancária",
                "bankName": "Nome do banco",
                "bankAddress": "Endereço do Banco",
                "iban": "IBAN"
            },
            "option": {
                "preferedMethod": {
                    "paypal": "Paypal",
                    "bankAccount": "Conta bancária"
                }
            },
            "help_text": {
                "profileImage": "Envie formatos JPG, resolução apenas 300x300 px, tamanho máximo 300 KB.",
                "iban": "Lembre-se do prefixo do seu país, por exemplo, DE, FR, ES"
            },
            "button": {
                "submit": "Enviar"
            }
        },
        "message": {
            "success": "Seu perfil foi atualizado!",
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!"
        },
        "modal": {
            "header": "Tem certeza de que gostaria de alterar seu perfil?",
            "body": "Por meio deste, você garante que todos os dados fornecidos são verdadeiros. Você é o único e legalmente responsável pelos dados fornecidos e pela veracidade de tais informações.",
            "button": {
                "cancel": "Cancelar",
                "confirm": "Confirmar"
            }
        }
    },
    "set_new_password": {
        "title": "Definir nova senha",
        "form": {
            "label": {
                "currentPassword": "Senha atual",
                "newPassword": "Nova senha",
                "repeatNewPassword": "Repita a nova senha"
            },
            "button": {
                "submit": "Enviar"
            },
            "validation": {
                "oldPasswordRequired": "Sua senha antiga é necessária",
                "newPasswordMin": "Sua senha deve ter no mínimo 10 caracteres",
                "newPasswordRequired": "Nova senha é necessária",
                "passwordsMustMatch": "A nova senha deve corresponder"
            }
        },
        "message": {
            "success": "Sua senha foi alterada!",
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!"
        },
        "modal": {
            "header": "Tem certeza de que gostaria de alterar sua senha?",
            "body": "Por favor, confirme"
        }
    },
    "panel": {
        "label": {
            "emailAddress": "Endereço de email",
            "paypalEmailAddress": "Endereço de email do Paypal",
            "phone": "Telefone",
            "streetAndHouseNumber": "Rua e número da casa",
            "postalCode": "Código Postal",
            "city": "Cidade",
            "country": "País",
            "paymentMethod": "Método de Pagamento",
            "accountNumberHolder": "Titular do Número da Conta",
            "bankName": "Nome do Banco",
            "iban": "IBAN",
            "bic": "BIC",
            "bankAddress": "Endereço do Banco",
            "paypal": "Paypal",
            "bankAccount": "Conta Bancária"
        }
    },
    "payment_method": {
        "title": "Método de Pagamento",
        "label": {
            "card_number": "Número do Cartão",
            "card_expiry": "Validade",
            "default_method": "Padrão",
            "manage_method": "Gerenciar",
            "add_method": "Adicionar"
        }
    },
    "withholding_tax": {
        "title": "Imposto Retido na Fonte",
        "form": {
            "label": {
                "taxPercentage": "Percentual de Imposto",
                "whtStatus": "Status do IRF",
                "whtLicense": "Licença do IRF"
            },
            "help_text": {
                "uploadDocument": "Por favor, envie seu documento de imposto retido na fonte."
            },
            "button": {
                "submit": "Enviar",
                "removeFile": "Remover?"
            },
            "message": {
                "whtStatusText": "De acordo com o Artigo 31 da Lei do Imposto sobre Lucros da Croácia, um imposto retido na fonte de 15-25% é aplicado a não residentes. No entanto, se você residir em um país que tenha um Acordo para Evitar a Dupla Tributação com a Croácia, poderá se qualificar para uma taxa de imposto reduzida. Você pode verificar se seu país está listado em <1><strong>este link</strong></1>.",
                "whtApplyRateText": "Para solicitar a taxa reduzida, clique em <1><strong>este documento</strong></1>. Baixe, complete e envie o formulário para se beneficiar da taxa especificada no acordo, se elegível."
            }
        },
        "message": {
            "success": "Licença de IRF enviada com sucesso. Será processada por nossa equipe.",
            "error": "Ocorreu um erro ao atualizar. Por favor, tente novamente."
        }
    }
};

export default profilePT;